import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const NotFound = () => {
    const [joke, setJoke] = useState('');

    useEffect(() => {
        // Create a separate axios instance for joke API to avoid affecting global config
        const jokeApi = axios.create({
            baseURL: 'https://api.humorapi.com/jokes/search',
            headers: {
                'x-api-key': 'f30acf5ebe844639ba04405d0c438138'
            },
            params: {
                'number': 1,
                'keywords': 'swedish,sweden,gothenburg' // Försök hitta svenska skämt
            }
        });

        const getJoke = async () => {
            try {
                const response = await jokeApi.get();
                if (response && response.data.jokes && response.data.jokes.length > 0){
                    setJoke(response.data.jokes[0].joke);
                } else {
                    // Fallback om inga skämt hittas med sökord
                    setJoke("Inget skämt hittades denna gång. Försök igen!");
                }
            } catch (error) {
                console.log(error);
                setJoke("Kunde inte hämta skämt just nu. Försök igen senare!");
            }
        };

        getJoke();
    }, [])

  

    return (
        <div className='flex justify-center items-center flex-col'>
            <div>
                <div className='flex text-4xl'>Oops, nothing here..</div>
                <Link to='/'>
                    <button className='flex items-center justify-center text-xl bg-grafokett-blue hover:bg-grafokett-blue-dark text-white p-3 pl-8 pr-8 rounded m-4 transition-colors duration-200 font-medium'>
                        <i className='fas fa-home mr-2'></i>
                        Navigate back home
                    </button>
                </Link>
            </div>
            <div className='mt-10 flex-col justify-items-center'>
                <h1 className=' text-2xl mb-6'>Njut av ett slumpmässigt skämt..</h1>
                <div className='flex text-xl max-w-2xl text-center'>
                    { joke ? <p>{joke}</p> : <p>Laddar skämt...</p> }
                </div>
            </div>
            
        </div>
        
    )
}

export default NotFound;